<template>
  <div class="container">
    <div class="content">
      <h3>{{ $t("order") }}</h3>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("customer") }}</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                :placeholder="$t('customer')"
                v-model="meta.customer"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-user"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("table") }}</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                :placeholder="$t('table')"
                v-model="meta.table"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-table"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("staff code") }}</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                :placeholder="$t('table')"
                v-model="meta.staff_code"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-user"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <h4>{{ $t("ordered plate list") }}</h4>

      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("options") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(plate, pidx) in ordered_plates" :key="pidx">
            <td>
              <div class="title is-6">{{ plate.name }}</div>
              <div class="subtitle is-6">{{ plate.customization }}</div>
            </td>
            <td>
              <div class="buttons are-small">
                <div
                  class="button is-primary is-rounded"
                  @click="customize_plate(plate)"
                >
                  <span class="icon">
                    <i class="fa fa-user"></i>
                  </span>
                  <span>{{ $t("customize") }}</span>
                </div>
                <div
                  class="button is-danger is-rounded"
                  @click="remove_plate(pidx)"
                >
                  <span class="icon">
                    <i class="fa fa-trash"></i>
                  </span>
                  <!-- <span>{{ $t("delete") }}</span> -->
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="buttons">
      <div class="button is-primary is-rounded" @click="make_order">
        <span class="icon">
          <i class="fa fa-check"></i>
        </span>
        <span>{{ $t("make order") }}</span>
      </div>
      <div class="button is-danger is-rounded" @click="clear">
        <span class="icon">
          <i class="fa fa-trash"></i>
        </span>
        <span>{{ $t("clear") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  warning_message,
  get,
  input_alert,
  post,
  error_message,
  success_message,
} from "@/utils";

export default {
  name: "FoodOrderEmiiter",
  components: {},
  data() {
    return {
      meta: {
        customer: "",
        table: "",
      },
      ordered_plates: [],
    };
  },
  methods: {
    set_plate(plate) {
      let v = this;
      v.ordered_plates.push({ ...plate });
    },
    remove_plate(index) {
      let v = this;
      v.ordered_plates.splice(index, 1);
    },
    customize_plate(plate) {
      let v = this;
      input_alert({
        title: v.$t("customization"),
        input_label: v.$t("detail meal customization"),
        input: "textarea",
        input_value: plate.customization,
      })
        .then((result) => {
          plate.customization = result;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    make_order() {
      let v = this;
      let data = {
        customer: v.meta.customer,
        table: v.meta.table,
        staff_code: v.meta.staff_code,
        plates: v.ordered_plates,
      };
      post("/restaurant/order", data)
        .then((response) => {
          success_message(v.$t("order created"));
          v.clear();
        })
        .catch((error) => {
          error_message(error);
        });
    },
    clear() {
      let v = this;
      v.meta.customer = "";
      v.meta.table = "";
      v.ordered_plates = [];
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
